(() => {
  const normalize = (value) => value.toLocaleLowerCase().normalize('NFKD').replace(/[\u0300-\u036f]/g, '').trim();

  if (!customElements.get('woofly-support-filter')) {
    customElements.define('woofly-support-filter', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.search = this.querySelector('[data-search]');
        this.buttons = Array.from(this.querySelectorAll('[data-filter]'));
        this.items = Array.from(this.querySelectorAll('[data-result]')).map((element) => ({ element, text: normalize(element.dataset.searchText || ''), category: element.dataset.category }));
        this.count = this.querySelector('[data-count]');
        this.empty = this.querySelector('[data-empty]');
        this.category = 'all';
        if (!this.search || !this.count || !this.empty) return;
        const params = new URL(window.location.href).searchParams;
        this.search.value = params.get('q') || '';
        const requestedCategory = params.get('category');
        if (this.buttons.some((button) => button.dataset.filter === requestedCategory)) this.category = requestedCategory;
        this.querySelector('[data-tools]').hidden = false;
        this.search.addEventListener('input', () => this.filter(true), options);
        this.querySelector('[data-search-form]').addEventListener('submit', (event) => { event.preventDefault(); this.filter(true); }, options);
        this.buttons.forEach((button) => button.addEventListener('click', () => { this.category = button.dataset.filter; this.filter(true); }, options));
        this.querySelector('[data-reset]').addEventListener('click', () => { this.search.value = ''; this.category = 'all'; this.filter(true); this.search.focus(); }, options);
        window.addEventListener('hashchange', () => this.openQuestion(), options);
        this.filter(false);
        this.openQuestion();
      }

      disconnectedCallback() {
        this.controller?.abort();
        this.initialized = false;
      }

      filter(updateUrl) {
        const terms = normalize(this.search.value).split(/\s+/).filter(Boolean);
        let visible = 0;
        this.items.forEach(({ element, text, category }) => {
          const match = (this.category === 'all' || this.category === category) && terms.every((term) => text.includes(term));
          element.hidden = !match;
          if (match) visible += 1;
        });
        this.buttons.forEach((button) => button.setAttribute('aria-pressed', String(button.dataset.filter === this.category)));
        this.empty.hidden = visible > 0;
        this.count.textContent = visible === 1 ? this.dataset.countOne : this.dataset.countMany.replace('__COUNT__', String(visible));
        if (updateUrl) {
          const url = new URL(window.location.href);
          const query = this.search.value.trim();
          query ? url.searchParams.set('q', query) : url.searchParams.delete('q');
          this.category !== 'all' ? url.searchParams.set('category', this.category) : url.searchParams.delete('category');
          let selectedId = '';
          try { selectedId = decodeURIComponent(url.hash.slice(1)); } catch { /* Leave unrelated fragments alone. */ }
          const selectedQuestion = this.items.find(({ element }) => element.id === selectedId)?.element;
          if (selectedQuestion?.hidden) url.hash = '';
          window.history.replaceState(window.history.state, '', url);
        }
      }

      openQuestion() {
        if (!window.location.hash) return;
        let id;
        try { id = decodeURIComponent(window.location.hash.slice(1)); } catch { return; }
        const target = this.items.find(({ element }) => element.id === id)?.element;
        if (!target || target.tagName !== 'DETAILS') return;
        this.search.value = '';
        this.category = 'all';
        this.filter(false);
        target.open = true;
        window.requestAnimationFrame(() => target.scrollIntoView({ block: 'start' }));
      }
    });
  }

  const connectContents = (scope) => {
    scope.querySelectorAll('.wf-support--article').forEach((article) => {
      const toc = article.querySelector('[data-article-toc]');
      const body = article.querySelector('[data-article-body]');
      if (!toc || !body || toc.dataset.initialized) return;
      const headings = Array.from(body.querySelectorAll('h2'));
      if (!headings.length) return;
      const list = toc.querySelector('ol');
      headings.forEach((heading, index) => {
        if (!heading.id) heading.id = `article-section-${index + 1}`;
        const item = document.createElement('li');
        const link = document.createElement('a');
        link.href = `#${encodeURIComponent(heading.id)}`;
        link.textContent = heading.textContent;
        item.append(link);
        list.append(item);
      });
      toc.dataset.initialized = 'true';
      toc.hidden = false;
    });
  };
  connectContents(document);
  document.addEventListener('shopify:section:load', (event) => connectContents(event.target));
})();
